import axios from 'axios';
import { showLoadingAction, hideLoadingAction } from '../../forms/loading-screen/actions';
import { env } from '../../env';
import { Claim, claimUpdatedThunk } from '../../claim';
import { ReduxThunkAction } from '../../redux/redux-actions';

type UpdateTaxDirectiveReturn = Promise<any>;
export type UpdateTaxDirective = (liabilityId?: string) => UpdateTaxDirectiveReturn;
type UpdateTaxDirectiveAction = (
    liabilityId?: string
) => ReduxThunkAction<UpdateTaxDirectiveReturn>;
export const updateTaxDirectiveActionAction: UpdateTaxDirectiveAction = (liabilityId?: string) => {
    return async (dispatch, getState) => {
        const claim = getState().claimSession.claim;
        const taxDirectiveUri = `${env().CLAIMS_API}/api/Claim/${
            claim.claimId
        }/Directive?liabilityId=${liabilityId}`;
        await submitTaxDirectives(dispatch, taxDirectiveUri);
    };
};

async function submitTaxDirectives(dispatch: any, taxDirectiveUri: string) {
    dispatch(showLoadingAction());
    await axios
        .post<Claim>(taxDirectiveUri)
        .then(response => {
            if (response.data) {
                dispatch(claimUpdatedThunk(response.data));
            }
        })
        .catch(error => {})
        .then(() => dispatch(hideLoadingAction()));
}
